import Styled from 'styled-components';

const Iframe = Styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colorSlate5};
  box-shadow: 0 0 2px ${({ theme }) => theme.colorSlate5};

  iframe {
    width: 100%;
  }
`;

Iframe.displayName = 'Iframe';

export default Iframe;
